export const transformLogs = (deviceLogs: any[]) => {
  return deviceLogs.slice(-30).map((singleData) => ({
    time: new Date(singleData.interval_time).toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    }),
    cpu: singleData.avg_cpu ? singleData.avg_cpu : null,
    ram: singleData.avg_ram ? singleData.avg_ram : null,
  }));
};

export const calculateYAxisDomain = (data: any[], step: number = 25) => {
  const maxCpu = Math.max(...data.map((d) => d.cpu));
  const maxRam = Math.max(...data.map((d) => d.ram));

  const maxValue = Math.max(maxCpu, maxRam);

  const upperLimit = Math.ceil(maxValue / step) * step;

  return [0, upperLimit];
};
